import { render, staticRenderFns } from "./Enroll.vue?vue&type=template&id=612fbf7c&scoped=true&"
import script from "./Enroll.vue?vue&type=script&lang=js&"
export * from "./Enroll.vue?vue&type=script&lang=js&"
import style0 from "./Enroll.vue?vue&type=style&index=0&id=612fbf7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612fbf7c",
  null
  
)

export default component.exports